import request from '@/utils/requestVr'
// 查询VR租户存储空间分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/tenant/page/capacity',
        method: 'get',
        params: query,
    })
}
// 查询本单位存储池
export function tenantPeronal(query) {
    return request({
        url: '/vr/storage/tenant/personal',
        method: 'get',
        params: query,
    })
}
// 详情
export function getObj(id) {
    return request({
        url: '/vr/storage/tenant/detail?id=' + id,
        method: 'get',
    })
}
export function delObj(data) {
    return request({
        url: '/vr/works/delete',
        method: 'post',
        data: data,
    })
}

export function editObj(data) {
    return request({
        url: '/vr/storage/tenant/edit',
        method: 'post',
        data: data,
    })
}

export function getDetail(params) {
  return request({
    url: `/vr/storage/tenant/detail`,
    method: 'get',
    params,
  })
}
